import angular from 'angular';

export default angular
  .module('app.directives.bind-compile', [])
  .directive('bindCompile', bindCompile);

function bindCompile($compile) {
  return {
    restrict: 'A',
    scope: {
      content: '=bindCompile',
    },
    link: function(scope, element) {
      function compile(content) {
        element.html(content);
        $compile(element.contents())(scope.$parent);
      }

      let watch = () => {
        return scope.content;
      };
      scope.$watch(watch, compile);
    },
  };
}
